import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../app-config.constants';
import { IAppConfig } from '../app-config.interface';
import { HttpClient } from '@angular/common/http';
import { Demographics } from '../classes/demographics';
import { environment } from '../../environments/environment-wrapper';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {Neighbourhood} from '../classes/neighbourhood';

@Injectable()
export class DemographicsService {

  constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig, private http: HttpClient) { }

  async getDemographics(lat: number, lng: number): Promise<Demographics> {
    return await this.http.get<any>(`${environment.baseServerUrl + this.appConfig.urls.demographics.point}?lat=${lat}&lng=${lng}`, { withCredentials: false })
      .pipe(
        map(res => new Demographics(res.result))
      ).toPromise();
  }

  async getNeighbourhood(lat: number, lng: number): Promise<Neighbourhood> {
    return await this.http.get<any>(`${environment.baseServerUrl + this.appConfig.urls.demographics.neighbourhoodPoint}?lat=${lat}&lng=${lng}`, { withCredentials: false})
      .pipe(
        map(res => {
          const neighbourhood = new Neighbourhood(res.result);
          return (neighbourhood.character && neighbourhood.detailUrl && neighbourhood.name) ? neighbourhood : null;
        }),
        catchError( (err) => {
          console.log('Error in retrieve neighbourhood', err);
          return of (null);
        })).toPromise();
  }
}
